<template>
    <div class="token">
        <partner-logo class="token__logo"
            :show-placeholder="true"
            :url="partner.partnerLogo"
            :onClick="goToPartner"
        />
        <div class="token__details"
            @click="goToWalletPartnerDetails"
        >
            <div class="token__name">{{ token.currency.label }}</div>
            <div v-if="isChzAllowed"
                class="token__balance"
            >
                {{ chzAmount }} <span class="token__balance--alt">{{ alternativeBalance }}</span>
            </div>
            <div v-else
                class="token__balance"
            >
                {{ fiatAmount }}
            </div>
            <div class="token__amount"><span class="bold">{{ totalTokensAmount }} </span>{{ `${token.currency.shortCode}` }}</div>
        </div>
    </div>
</template>

<script>
// Mixins
import tokenCardMixin from '@webapp/helpers/token-card-mixin.js';

// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';

export default {
    name: 'wallet-card',
    components: {
        partnerLogo,
    },
    mixins: [tokenCardMixin],
    props: {
        token: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.token {
    display: flex;
    background: $white-color;
    border-radius: 8px;
    padding: 0.8rem 1.6rem 0.8rem 1.2rem;
    margin-bottom: 1.2rem;
    cursor: pointer;

    @include max-width(lg) {
        padding: 1.2rem 2.4rem 1.2rem 2rem;
        margin-bottom: 1.4rem;
    }

    &__logo {
        height: 4.5rem;
        width: 4.5rem;
        margin-right: 1.8rem;

        @include max-width(lg) {
            height: 6rem;
            width: 6rem;
            margin-right: 2rem;
        }
    }

    &__details {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include max-width(lg) {
            flex-wrap: wrap;
        }
    }

    &__name {
        font-size: 1.5rem;
        font-weight: 700;
        flex: 1;
        max-width: 28rem;

        @include max-width(lg) {
            font-size: 1.3rem;
            max-width: 50%;
            order: 1;
        }
    }

    &__balance {
        font-size: 1.3rem;
        margin-right: auto;

        @include max-width(lg) {
            font-size: 1.1rem;
            width: 100%;
            order: 3;
            padding-top: 0.8rem;
            border-top: 0.1rem solid $blue-dark-color;
        }

        &--alt {
            color: $hit-gray-color;
        }
    }

    &__amount {
        font-size: 1.7rem;
        max-width: 15rem;
        flex: 1;
        text-align: right;

        @include max-width(lg) {
            font-size: 1.5rem;
            max-width: 50%;
            order: 2;
        }
    }
}

.bold {
    font-weight: 700;
}
</style>